export const ID_PRESETS = {
  'category-roads-barrier': {
    name: 'Barrier Features',
    members: [
      'barrier/fence',
      'barrier/wall',
      'barrier/ditch',
      'barrier/gate',
      'barrier/hedge',
      'barrier/kerb',
      'barrier',
    ],
  },
  'category-building': {
    name: 'Building Features',
    members: [
      'building',
      'building/house',
      'building/apartments',
      'building/garage',
      'building/retail',
      'building/commercial',
      'building/industrial',
      'building/residential',
    ],
  },
  'category-landuse': {
    name: 'Land Use Features',
    members: [
      'landuse/residential',
      'landuse/industrial',
      'landuse/commercial',
      'landuse/retail',
      'landuse/farmland',
      'landuse/farmyard',
      'landuse/forest',
      'landuse/meadow',
      'landuse/aquaculture',
      'landuse/cemetery',
      'landuse/military',
      'landuse/religious',
    ],
  },
  'category-natural': {
    name: 'Natural Features',
    members: [
      'natural/water',
      'natural/wood',
      'natural/scrub',
      'natural/wetland',
      'natural/grassland',
      'natural/heath',
      'natural/bare_rock',
      'natural/beach',
      'natural/cave_entrance',
      'natural/glacier',
      'natural/coastline',
      'natural/tree_row',
      'natural/peak',
      'natural/cliff',
      'natural/beach',
    ],
  },
  'category-roads-path': {
    name: 'Paths',
    members: [
      'highway/path',
      'highway/footway',
      'highway/footway/marked',
      'highway/footway/sidewalk',
      'highway/steps',
      'highway/cycleway',
      'highway/bridleway',
      'highway/pedestrian_line',
    ],
  },
  'category-other-rail': {
    name: 'Rails',
    members: [
      'railway/rail',
      'railway/disused',
      'railway/tram',
      'railway/subway',
      'railway/narrow_gauge',
      'railway/light_rail',
      'railway/monorail',
      'railway/funicular',
    ],
  },
  'category-roads-restriction': {
    name: 'Restriction Features',
    members: [
      'type/restriction/no_left_turn',
      'type/restriction/no_right_turn',
      'type/restriction/no_straight_on',
      'type/restriction/no_u_turn',
      'type/restriction/only_left_turn',
      'type/restriction/only_right_turn',
      'type/restriction/only_straight_on',
      'type/restriction/only_u_turn',
      'type/restriction',
    ],
  },
  'category-roads-major': {
    name: 'Major Roads',
    members: [
      'highway/motorway',
      'highway/trunk',
      'highway/primary',
      'highway/secondary',
      'highway/tertiary',
      'highway/motorway_link',
      'highway/trunk_link',
      'highway/primary_link',
      'highway/secondary_link',
      'highway/tertiary_link',
    ],
  },
  'category-roads-minor': {
    name: 'Minor Roads',
    members: [
      'highway/unclassified',
      'highway/residential',
      'highway/living_street',
      'highway/service',
      'highway/track',
    ],
  },
  'category-roads-service': {
    name: 'Service Roads',
    members: [
      'highway/service',
      'highway/service/parking_aisle',
      'highway/service/driveway',
      'highway/service/alley',
      'highway/service/emergency_access',
      'highway/service/drive-through',
    ],
  },
  'category-roads-route': {
    name: 'Route Features',
    members: [
      'type/route/road',
      'type/route/bicycle',
      'type/route/foot',
      'type/route/hiking',
      'type/route/horse',
      'type/route/piste',
      'type/route/bus',
      'type/route/train',
      'type/route/light_rail',
      'type/route/tram',
      'type/route/subway',
      'type/route/ferry',
      'type/route/power',
      'type/route/pipeline',
      'type/route/detour',
      'type/route_master',
      'type/route',
    ],
  },
  'category-other-utility': {
    name: 'Utility Features',
    members: ['power/line', 'power/minor_line', 'man_made/pipeline', 'power/cable/underground'],
  },
  'category-water': {
    name: 'Water Bodies',
    members: [
      'natural/water',
      'natural/water/pond',
      'natural/water/basin',
      'natural/water/lake',
      'natural/water/reservoir',
    ],
  },
  'category-waterway': {
    name: 'Waterways',
    members: [
      'waterway/stream',
      'waterway/drain',
      'waterway/river',
      'waterway/canal',
      'waterway/ditch',
      'natural/water/stream',
      'natural/water/river',
      'natural/water/canal',
    ],
  },
  'category-places': {
    name: 'Places',
    members: [
      'place',
      'place/locality',
      'place/isolated_dwelling',
      'place/hamlet',
      'place/village',
      'place/neighbourhood',
      'place/suburb',
      'place/town',
    ],
  },
  'category-others': {
    name: 'Others',
    members: ['ford'],
  },
};
